import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Bus from '@/helpers/EventBus';
import { formatTicketCount } from '@/helpers/StringHelpers';
import { closeCartModal, openCartModal } from '@/modals/cartModal';
@Component({
    components: {},
    computed: mapGetters({
        ticketCount: 'Cart/ticketCount',
    }),
})
export default class MobileCartButton extends Vue {
    // Vuex getters
    ticketCount;
    open = false;
    created() {
        Bus.$on('opened:modal', ({ options }) => {
            if (options.name === 'mobile-cart') {
                this.open = true;
            }
        });
        Bus.$on('closed:modal', ({ instance }) => {
            if (instance.name === 'mobile-cart') {
                this.open = false;
            }
        });
    }
    get displayTicketCount() {
        return formatTicketCount(this.ticketCount);
    }
    toggleCart() {
        if (this.open) {
            closeCartModal();
        }
        else {
            openCartModal();
        }
    }
}
